import {
  EClickableSize,
  EClickableTypes,
  EClickableVariants,
} from '@/components/atoms/at-clickable/at-clickable.types';
import { IHousePlanHit } from '@/lib/search/types';
import { IOrDesignStudioBlockProps } from './or-design-studio-block.types';

export const orDesignStudiosRelatedHomePlans: IHousePlanHit[] = [
  {
    ExteriorStyle: { Name: 'American Tradition' },
    Name: 'Santa Barbara American Tradition',
    Plan: {
      Name: 'Santa Barbara',
    },
    Image: '/assets/olivia.jpg',
  },
  {
    ExteriorStyle: { Name: 'Classic' },
    Name: 'Charleston Classic',
    Plan: {
      Name: 'Charleston',
    },
    Image: '/assets/olivia.jpg',
  },
] as IHousePlanHit[];

export const orDesignStudioBlockMockData: IOrDesignStudioBlockProps = {
  title: 'See our work in person',
  ctaProps: [
    {
      label: 'Plan a Visit',
      variant: EClickableVariants.PRIMARY,
      interactLocation: 'test',
      href: '/plan-a-visit',
      size: EClickableSize.LG,
      type: EClickableTypes.CTA,
    },
    {
      label: 'See Upcoming Events',
      variant: EClickableVariants.PRIMARY,
      type: EClickableTypes.LINK,
      href: '/upcoming-events',
      size: EClickableSize.SM,
      interactLocation: 'test',
    },
  ],
  designStudio: {
    objectID: '6545684658',
    Id: 6545684658,
    Name: 'Raleigh-Durham Design Studio',
    image: {
      alt: 'Raleigh-Durham Design Studio',
      src: {
        desktop: '/assets/design-studio.jpg',
        tablet: '/assets/design-studio.jpg',
        mobile: '/assets/design-studio.jpg',
      },
    },
    Address: '182 West Hamlin Rd.',
    City: 'Benson',
    State: 'NC',
    Zip: '27504',
    relatedModels: [],
    isDigital: false,
    isVirtual: false,
    ParentId: null,
    States: [],
  },
} as IOrDesignStudioBlockProps;
